import { render, staticRenderFns } from "./ProductDetailSection.vue?vue&type=template&id=5500ad32&scoped=true"
import script from "./ProductDetailSection.vue?vue&type=script&lang=js"
export * from "./ProductDetailSection.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailSection.vue?vue&type=style&index=0&id=5500ad32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5500ad32",
  null
  
)

export default component.exports